module.exports = __webpack_public_path__ + "img/norwich.b1c8b4a2.png";